module.exports = __webpack_public_path__ + "img/app_general.f9d3f6a7.png";